import React, { Component } from "react";
import { connect } from 'react-redux';
import "tabler-react/dist/Tabler.css";
import Routes from './routes/routes';
import axiosApiInstance from "./http"; // Using your configured Axios instance
import actions from './redux/auth/action';
const API_URL = process.env.REACT_APP_apiUrl;

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // 1. ADD A LOADING FLAG. Start it as true so we hide the app immediately.
      isCheckingSession: true 
    };
  }
  componentDidMount() {
    this.checkSession();
  }

  checkSession = async () => {
    try {
      // Ping the backend to see if the HttpOnly cookie is valid.
      // Make sure '/admins/me' matches your actual backend route!
      const response = await axiosApiInstance.get(`${API_URL}admins/me`); 
      
      // If successful, log the user into Redux
      if (response && response.data && response.data.statusCode === 200) {
          this.props.authLogin(response.data);
      }
    } catch (error) {
      // If it returns 401, the cookie is invalid or missing. Ensure Redux is logged out.
      this.props.authLogout();
    } finally {
      // 2. STOP LOADING. This runs no matter what (success or failure)
      // Once this is false, React will finally render the correct page.
      this.setState({ isCheckingSession: false });
    }
  };

  render() {

    if (this.state.isCheckingSession) {
      // You can replace this with your actual CSS loader/spinner component
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <h2>Loading...</h2> 
        </div>
      );
    }
    return (
        <Routes />
    );
  }
}

// Map the dispatch actions to component props
const mapDispatchToProps = (dispatch) => {
  return {
    authLogin: (payload) => dispatch({ type: 'AUTH_LOGIN', payload: payload }),
    authLogout: () => dispatch(actions.authLogout())
  };
};

export default connect(null, mapDispatchToProps)(App);